import script from "./ShelfCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShelfCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./ShelfCarousel.vue?vue&type=style&index=0&id=27b5bae5&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b5bae5"]])

export default __exports__